// export const apiUrl = "http://localhost:59633"
export const apiUrl = process.env.REACT_APP_API_URL;

// ÐÐ¾ÐµÐ²Ð¾Ð¹ ÑÑÐµÐ½Ð´ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÐ¼ Ð¿Ð¾ Ð°Ð´ÑÐµÑÑ API. ÐÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ, ÑÑÐ¾Ð±Ñ ÑÐµÑÑÐ¾Ð²ÑÐµ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ð¸
// (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÑÐ¼ÑÐ»ÑÑÐ¸Ñ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ) Ð±ÑÐ»Ð¸ Ð²Ð¸Ð´Ð½Ñ Ð²ÐµÐ·Ð´Ðµ, ÐºÑÐ¾Ð¼Ðµ Ð¿ÑÐ¾Ð´Ð°.
// ÐÐ¾ÐµÐ²ÑÐ¼ ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð²ÑÑ, ÐºÑÐ¾Ð¼Ðµ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÐºÐ¸ Ð¸ ÑÑÐµÐ½Ð´Ð¾Ð² Ñ Ð¿ÑÐ¸ÑÑÐ°Ð²ÐºÐ¾Ð¹ test- Ð² Ð°Ð´ÑÐµÑÐµ:
// Ñ DOSCAR Ð¸ JetQ ÑÑÐ¾ app.<Ð´Ð¾Ð¼ÐµÐ½> Ð¿ÑÐ¾ÑÐ¸Ð² test-app.<Ð´Ð¾Ð¼ÐµÐ½>, Ñ Ð±ÑÐ¾ÐºÐµÑÐ¾Ð² Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð² â
// <Ð¿Ð°ÑÑÐ½ÑÑ>-app.hatc.kz Ð¿ÑÐ¾ÑÐ¸Ð² test-<Ð¿Ð°ÑÑÐ½ÑÑ>-app.hatc.kz. Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð¿ÑÐ¾Ð²ÐµÑÑÐ»ÑÑ ÑÐ¾Ð»ÑÐºÐ¾
// app.doscar.kz, Ð¿Ð¾ÑÐ¾Ð¼ app.<Ð´Ð¾Ð¼ÐµÐ½> â Ð¸ Ð½Ð° Ð±Ð¾ÐµÐ²Ð¾Ð¼ JS Avto Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÑÐ½Ð¾Ð²Ð° ÑÐ²Ð¸Ð´ÐµÐ»Ð¸
// ÑÐµÑÑÐ¾Ð²ÑÐ¹ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Â«ÑÑÐ¸ÑÐ°ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¿Ð¾Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸ÑÂ».
export const isProdApiUrl = (url) => {
  const trimmed = String(url || '').trim();
  if (!trimmed) return false;
  const host = trimmed.replace(/^https?:\/\//i, '').split(/[/?#]/)[0].split('@').pop().split(':')[0];
  if (!host || /^(localhost|127\.0\.0\.1|\[?::1\]?)$/i.test(host)) return false;
  return !/^test-/i.test(host);
};
export const IS_PROD_STAND = isProdApiUrl(process.env.REACT_APP_API_URL);
export const apiAdminUrl = process.env.REACT_APP_API_ADMIN_URL;
export const localApiUrl = process.env.REACT_APP_LOCAL_API_URL;
// export const apiUrl = 'https://test-app.doscar.kz';
// export const apiAdminUrl = 'https://test-admin.doscar.kz';
export const PAYMENT_TYPES_PREPAYMENT_INVOICE = 4;
export const PAYMENT_TYPES_PREPAYMENT_CARD = 5;
// ÐÐ¾ÐºÑÐ¿ÐºÐ° Ð·Ð° Ð¿Ð¾Ð»Ð½ÑÑ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ, Ð±ÐµÐ· ÐºÑÐµÐ´Ð¸ÑÐ°: Ð¿ÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ°, Ð¿Ð¾ ÑÑÑÑÑ, ÐºÐ°ÑÑÐ¾Ð¹.
export const FULL_PAYMENT_TYPE_IDS = [1, PAYMENT_TYPES_PREPAYMENT_INVOICE, PAYMENT_TYPES_PREPAYMENT_CARD];
export const PAYMENT_TYPES_CREDIT_CARD = 7;
export const PAYMENT_TYPES_CREDIT_INVOICE = 6;
export const PAYMENT_TYPES_OPTIONS = [
  { value: PAYMENT_TYPES_PREPAYMENT_INVOICE, label: 'ÐÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ° (ÑÑÐµÑ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ)' },
  { value: PAYMENT_TYPES_PREPAYMENT_CARD, label: 'ÐÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ° (Ð¾Ð¿Ð»Ð°ÑÐ° ÐºÐ°ÑÑÐ¾Ð¹)' },
  { value: PAYMENT_TYPES_CREDIT_INVOICE, label: 'ÐÐ²ÑÐ¾ÐºÑÐµÐ´Ð¸Ñ' },
  // { value: PAYMENT_TYPES_CREDIT_CARD, label: 'ÐÐ²ÑÐ¾ÐºÑÐµÐ´Ð¸Ñ (Ð¾Ð¿Ð»Ð°ÑÐ° ÐºÐ°ÑÑÐ¾Ð¹)' },
];

export const CREDIT_TYPE_ID = 3;
export const INSURANCE_ID = 6;

export const INSURANCE_SERVICE_ID_2_5 = 8;
export const INSURANCE_SERVICE_ID_3 = 6;
export const INSURANCE_SERVICE_ID_3_5 = 7;

export const DOCUMENT_TYPES_INVOICE = 1;
export const DOCUMENT_TYPES_CONTRACT = 2;
export const DOCUMENT_TYPES_POLES = 3;
export const DOCUMENT_TYPES_PAYMENT_CONFIRMATION = 4;
export const DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT = 5;
export const DOCUMENT_TYPES_POWER_OF_ATTORNEY = 7;
export const DOCUMENT_TYPES_SPOUSE_CONSENT = 8;
export const DOCUMENT_TYPES_TECH_PASSPORT = 9;
export const DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT = 19;
export const DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES = 20;

export const DOCUMENT_TYPES_GRNZ = 12;
export const DOCUMENT_TYPES_PLEDGE_AGREEMENT = 13;
export const DOCUMENT_TYPES_PLEDGE_APPLICATION = 14;
export const DOCUMENT_TYPES_UDV = 15;
export const DOCUMENT_TYPES_UDV_SPOUSE = 16;
export const DOCUMENT_TYPES_NO_TAX_DEBT = 17;
export const DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN = 18;
export const DOCUMENT_TYPES_GUARANTEE_LETTER = 23;
export const DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES = 24;
export const DOCUMENT_TYPES_PAYMENT_ORDER = 25;
export const DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE = 32;
export const DOCUMENT_TYPES_MARRIAGE_CONTRACT = 31;
export const DOCUMENT_TYPES_VEHICLE_RETURN_CONFIRMATION_LETTER = 34;
export const DOCUMENT_TYPES_LOAN_APPROVAL_NOTIFICATION = 37;
// ÐÑÐ°ÑÐ¸Ðº Ð¿Ð»Ð°ÑÐµÐ¶ÐµÐ¹ Ð±Ð°Ð½ÐºÐ°. Jet Finance Ð³Ð°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ð³Ð¾ Ð¿Ð¸ÑÑÐ¼Ð° Ð½Ðµ Ð²ÑÐ´Ð°ÑÑ, Ð¸ ÑÑÐ¾
// ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð¼Ñ Ð¾Ñ Ð½ÐµÐ³Ð¾ Ð¿Ð¾Ð»ÑÑÐ°ÐµÐ¼.
export const DOCUMENT_TYPES_PAYMENT_SCHEDULE = 50;
export const DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION = 41; // ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ
export const DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION = 42; // ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)
export const DOCUMENT_TYPES_ORIGIN_CERTIFICATE = 43; // Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ð¸ ÑÐ¾Ð²Ð°ÑÐ°
export const DOCUMENT_TYPES_CUSTOMER_LICENSE_CAR_ASSESSMENT = 44; // Ð£ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ° (Ð¾ÑÐµÐ½ÐºÐ° Ð°Ð²ÑÐ¾)
export const DOCUMENT_TYPES_TECH_PASSPORT_CAR_ASSESSMENT = 45; // Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ (Ð¾ÑÐµÐ½ÐºÐ° Ð°Ð²ÑÐ¾)
export const DOCUMENT_TYPES_CAR_PHOTO_CAR_ASSESSMENT = 46; // Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ (Ð¾ÑÐµÐ½ÐºÐ° Ð°Ð²ÑÐ¾)
export const DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT = 47; // Ð¤Ð¾ÑÐ¾ VIN-ÐºÐ¾Ð´Ð° (Ð¾ÑÐµÐ½ÐºÐ° Ð°Ð²ÑÐ¾)
export const DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT = 48; // Ð¤Ð¾ÑÐ¾ Ð¾Ð´Ð¾Ð¼ÐµÑÑÐ° (Ð¾ÑÐµÐ½ÐºÐ° Ð°Ð²ÑÐ¾)
export const DOCUMENT_TYPES_TRIPARTITE_CONTRACT = 49; // Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ ÐºÑÐ¿Ð»Ð¸-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ (Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ)

export const DOCUMENT_STATUS_SIGNED = 3;
export const DOCUMENT_STATUS_SIGNED_BY_DIRECTOR = 6;

export const DOCUMENT_TYPES_OPTIONS = [
  { value: DOCUMENT_TYPES_INVOICE, label: 'Ð¡ÑÐµÑ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ' },
  { value: DOCUMENT_TYPES_CONTRACT, label: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÐºÑÐ¿Ð»Ð¸ Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸' },
  { value: DOCUMENT_TYPES_POLES, label: 'ÐÐ¾Ð»Ð¸Ñ' },
  { value: DOCUMENT_TYPES_PAYMENT_CONFIRMATION, label: 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¾Ð¿Ð»Ð°ÑÑ' },
  { value: DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT, label: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ' },
  { value: DOCUMENT_TYPES_SPOUSE_CONSENT, label: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð¸' },
  { value: DOCUMENT_TYPES_POWER_OF_ATTORNEY, label: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ' },
  { value: DOCUMENT_TYPES_TECH_PASSPORT, label: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ (ÑÐºÐ°Ð½)' },
  { value: DOCUMENT_TYPES_GUARANTEE_LETTER, label: 'ÐÐ°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ðµ Ð¿Ð¸ÑÑÐ¼Ð¾' },
  { value: DOCUMENT_TYPES_PAYMENT_ORDER, label: 'ÐÐ»Ð°ÑÐµÐ¶Ð½Ð¾Ðµ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ Ð±Ð°Ð½Ðº' },
];

export const MARITAL_STATUS_UNDEFINED = 0;
export const MARITAL_STATUS_SINGLE = 1;
export const MARITAL_STATUS_MARRIED = 2;
export const MARITAL_STATUS_WIDOWED = 3;
export const MARITAL_STATUS_LIVING_TOGETHER = 4;
export const MARITAL_STATUS_DIVORCED = 5;

export const MARITAL_STATUS_OPTIONS = [
  {
    label: 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð¾',
    value: MARITAL_STATUS_UNDEFINED,
  },
  {
    label: 'Ð¥Ð¾Ð»Ð¾ÑÑ/ÐÐµ Ð·Ð°Ð¼ÑÐ¶ÐµÐ¼',
    value: MARITAL_STATUS_SINGLE,
  },
  {
    label: 'ÐÐµÐ½Ð°Ñ/ÐÐ°Ð¼ÑÐ¶ÐµÐ¼',
    value: MARITAL_STATUS_MARRIED,
  },
  {
    label: 'ÐÐ´Ð¾Ð²ÐµÑ/ÐÐ´Ð¾Ð²Ð°',
    value: MARITAL_STATUS_WIDOWED,
  },
  {
    label: 'ÐÑÐ°Ð¶Ð´Ð°Ð½ÑÐºÐ¸Ð¹ Ð±ÑÐ°Ðº',
    value: MARITAL_STATUS_LIVING_TOGETHER,
  },
  {
    label: 'Ð Ð°Ð·Ð²ÐµÐ´ÐµÐ½',
    value: MARITAL_STATUS_DIVORCED,
  },
];

export const CLIENT_DOCUMENT_TYPE = [
  { value: 1, label: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸' },
  { value: 5, label: 'ÐÐ¸Ð¿Ð»Ð¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð¿Ð°ÑÐ¿Ð¾ÑÑ' },
  { value: 2, label: 'ÐÐ°ÑÐ¿Ð¾ÑÑ' },
  { value: 4, label: 'ÐÐ¸Ð´ Ð½Ð° Ð¶Ð¸ÑÐµÐ»ÑÑÑÐ²Ð¾ Ð¸Ð½Ð¾ÑÑÑÐ°Ð½ÑÐ°' },
  { value: 8, label: 'ÐÐ¸ÑÐ¾ Ð±ÐµÐ· Ð³ÑÐ°Ð¶Ð´Ð°Ð½ÑÑÐ²Ð° Ð Ð' },
];

export const CLIENT_DOCUMENT_ISSUED_BY = [
  { value: 1, label: 'ÐÐÐ Ð Ð', code: 'MINISTRY_OF_THE_INTERIOR' },
  { value: 2, label: 'ÐÐ® Ð Ð', code: 'MINISTRY_OF_JUSTICE' },
];

export const CLIENT_NOTARIAL_VERIFICATION_PENDING = 1;
export const CLIENT_NOTARIAL_VERIFICATION_APPROVED = 2;
export const CLIENT_NOTARIAL_VERIFICATION_REJECTED = 3;

export const CLIENT_NOTARIAL_VERIFICATION_OPTIONS = [
  { value: CLIENT_NOTARIAL_VERIFICATION_PENDING, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸' },
  { value: CLIENT_NOTARIAL_VERIFICATION_APPROVED, label: 'ÐÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ' },
  { value: CLIENT_NOTARIAL_VERIFICATION_REJECTED, label: 'ÐÐµ Ð¿ÑÐ¾ÑÐµÐ» Ð¿ÑÐ¾Ð²ÐµÑÐºÑ' },
];

export const PAYMENT_STATUS_PAID = 1;
export const PAYMENT_STATUS_NOT_PAID = 2;

export const DEAL_STATUS_DOCUMENTS_PROCESSING = 1;
export const DEAL_STATUS_FULL_PAYMENT = 2;
export const DEAL_STATUS_REMARKS = 3;
export const DEAL_STATUS_ACT_UPLOADED = 4;
export const DEAL_STATUS_FAILED = 5;
export const DEAL_STATUS_COMPLETED = 6;
export const DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED = 7;
export const DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS = 8;
export const DEAL_STATUS_NEED_TO_MAKE_POWER_OF_ATTORNEY = 9;
export const DEAL_STATUS_WAITING_FOR_PAYMENT = 10;
export const DEAL_STATUS_CAR_ISSUED = 11;
export const DEAL_STATUS_WAIRING_REGISTRATION = 12;
export const DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT = 13;
export const DEAL_STATUS_CONTRACT_SIGNED = 15;
export const DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT = 14;
export const DEAL_STATUS_WAITING_FOR_PLEDGE_DOCUMENTS = 17;
export const DEAL_STATUS_WAITING_SIGNING_APPLICATION_FOR_ADDITIONAL_SERVICES = 16;
export const DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT = 18;
export const DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS = 17;
export const DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT = 19;
// Ð­ÑÐ°Ð¿ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¸ Ð°Ð½ÐºÐµÑÐ°: ÑÐ°Ð½ÑÑÐµ Ð½Ð° Ð½Ð¸Ñ ÑÑÐ¾ÑÐ» Â«ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¾Ð¿Ð»Ð°ÑÑÂ».
export const DEAL_STATUS_WAITING_CONSENT_SIGNING = 25;
export const DEAL_STATUS_WAITING_BANK_DECISION = 26;
export const DEAL_STATUS_BANK_APPROVED = 27;
export const DEAL_STATUS_FILLING_QUESTIONNAIRE = 28;

export const DEAL_STATUS_WAITING_FOR_FREEDOM = 20;
export const DEAL_STATUS_WAITING_FOR_HALYK = 21;

export const DEAL_STATUS_CAR_DELIVERY = 22;
export const DEAL_STATUS_REJECTED = 23;

export const DEAL_STATUSES = [
  { value: DEAL_STATUS_DOCUMENTS_PROCESSING, label: 'ÐÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ Ð´Ð¾Ðº-Ð²' },
  { value: DEAL_STATUS_FULL_PAYMENT, label: 'ÐÐ¾Ð»Ð½Ð°Ñ Ð¾Ð¿Ð»Ð°ÑÐ°' },
  { value: DEAL_STATUS_REMARKS, label: 'ÐÐ°Ð¼ÐµÑÐ°Ð½Ð¸Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ' },
  { value: DEAL_STATUS_ACT_UPLOADED, label: 'ÐÐºÑ Ð/Ð Ð¿Ð¾Ð´Ð³ÑÑÐ¶ÐµÐ½' },
  { value: DEAL_STATUS_FAILED, label: 'Ð¡Ð´ÐµÐ»ÐºÐ° Ð¿ÑÐ¾Ð²Ð°Ð»ÐµÐ½Ð°' },
  { value: DEAL_STATUS_COMPLETED, label: 'ÐÐ°Ð²ÐµÑÑÐµÐ½Ð°' },
  { value: DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED, label: 'ÐÐ¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ñ' },
  { value: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð½Ð¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²' },
  {
    value: DEAL_STATUS_NEED_TO_MAKE_POWER_OF_ATTORNEY,
    label: 'ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð¸ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð½Ð° ÑÑÐµÑ',
  },
  { value: DEAL_STATUS_WAITING_FOR_PAYMENT, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¾Ð¿Ð»Ð°ÑÑ' },
  { value: DEAL_STATUS_WAIRING_REGISTRATION, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ' },
  { value: DEAL_STATUS_CAR_ISSUED, label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð²ÑÐ´Ð°Ð½Ð°' },
  { value: DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°' },
  { value: DEAL_STATUS_CONTRACT_SIGNED, label: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½' },
  { value: DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼' },
  { value: DEAL_STATUS_REJECTED, label: 'ÐÐµÑÐ´Ð°ÑÐ½Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°' },
];

export const CAR_DOCUMENT_TYPES = [
  { value: 1, label: 'Ð¡Ð²Ð¸Ð´ÐµÑÐµÐ»ÑÑÑÐ²Ð¾ Ð¾ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð¢Ð¡' },
  { value: 2, label: 'ÐÐ¢Ð¡' },
  { value: 3, label: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾Ð± Ð¾Ð¿Ð»Ð°ÑÐµ ÑÑÐ¸Ð»Ð¸Ð·Ð°ÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ ÑÐ±Ð¾ÑÐ°' },
  { value: 4, label: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ñ' },
  { value: 5, label: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ð¸ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸' },
  { value: 6, label: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð²ÑÐºÑÐ¿Ð°' },
  { value: 7, label: 'ÐÐºÑ Ð¿ÑÐ¸ÑÐ¼ÐºÐ¸/Ð¾ÑÐ¼Ð¾ÑÑÐ° Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
  { value: 8, label: 'Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
];

export const CLIENT_CONTACT_PERSON_TYPES = [
  { value: 'ÐÐµÐ½Ð°', label: 'ÐÐµÐ½Ð°' },
  { value: 'ÐÑÐ¶', label: 'ÐÑÐ¶' },
  { value: 'ÐÐ°Ð¼Ð°', label: 'ÐÐ°Ð¼Ð°' },
  { value: 'ÐÑÐµÑ', label: 'ÐÑÐµÑ' },
  { value: 'ÐÐ¾ÑÑ', label: 'ÐÐ¾ÑÑ' },
  { value: 'Ð¡ÑÐ½', label: 'Ð¡ÑÐ½' },
  { value: 'ÐÑÐ°Ñ', label: 'ÐÑÐ°Ñ' },
  { value: 'Ð¡ÐµÑÑÑÐ°', label: 'Ð¡ÐµÑÑÑÐ°' },
  { value: 'ÐÐ¾Ð»Ð»ÐµÐ³Ð¸', label: 'ÐÐ¾Ð»Ð»ÐµÐ³Ð¸' },
  { value: 'ÐÑÑÐ·ÑÑ', label: 'ÐÑÑÐ·ÑÑ' },
];

export const RESIDENT_TYPES = [
  { value: 1, label: 'Ð ÐµÐ·Ð¸Ð´ÐµÐ½Ñ' },
  { value: 0, label: 'ÐÐµ ÑÐµÐ·Ð¸Ð´ÐµÐ½Ñ' },
];

export const BANKS = {
  EURAZ: 1,
  BCK: 2,
  FREEDOM: 3,
  BEREKE: 4,
  // HALYK: 5,
  HALYK: 5,
  FORTE: 6,
  SHINHAN: 7,
  ALTYN: 8,
  TFS: 9,
  SAPA: 10,
  MYCAR: 11,
  JETFIN: 14,
  SOLVA: 15,
  // ÐÐ¤Ð Ð½Ð° ÐºÐ¾Ð½Ð²ÐµÐ¹ÐµÑÐµ Ð¡Ð°Ð¿Ñ; Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ â Ð·Ð°Ð³Ð»ÑÑÐºÐ°, Ð¿Ð¾ÐºÐ° ÐÐ¤Ð Ð½Ðµ Ð¿ÑÐ¸ÑÐ»ÑÑ ÑÐ²Ð¾Ñ.
  PLEDGECAR: 16,
  TEST: 100,
};

// ÐÐ¾Ð½Ð²ÐµÐ¹ÐµÑ Ð¡Ð°Ð¿Ñ: Ñ Ð¾ÑÑÐµÑÐ¾Ð² ÑÑÑÐ°ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¶Ð¸Ð·Ð½Ð¸, Ð¿Ð¾Ð¼Ð¾ÑÑ Ð½Ð° Ð´Ð¾ÑÐ¾Ð³Ðµ Ð¸ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð°Ð²ÑÐ¾.
// PledgeCar ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð½Ð° Ð½ÑÐ¼ Ð¶Ðµ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð´ÐµÑÐ°Ð»Ð¸ Ð¾ÑÑÐµÑÐ° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾.
export const SAPA_CONVEYOR_BANK_IDS = [BANKS.SAPA, BANKS.PLEDGECAR];
export const isSapaConveyor = (bankId) => SAPA_CONVEYOR_BANK_IDS.includes(Number(bankId));

// ÐÐ°Ð½ÐºÐ¸, Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÑÑÐ¸Ðµ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¿Ð¾ ÐÐ£-Ð°Ð²ÑÐ¾ (Ð²ÑÐºÑÐ¿, Ð¼ÐµÐ½Ð°, Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ).
// ÐÐ»ÑÑÐ½ Ð¸ Ð¤Ð¾ÑÑÐµ ÐÐ£ Ð½Ðµ ÑÐ°Ð·Ð»Ð¸ÑÐ°ÑÑ Ð¸Ð»Ð¸ Ð½Ðµ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÑÑ â Ð¸Ð¼ Ð½Ðµ ÑÐ»ÑÐ¼.
export const USED_CAR_BANK_IDS = [
  BANKS.EURAZ,
  BANKS.BCK,
  BANKS.FREEDOM,
  // ÐÐµÑÐµÐºÐµ Ñ 04.11.2026: ÑÑÐ±Ð¿ÑÐ¾Ð´ÑÐºÑÑ 121 (ÐÐ£) Ð¸ 155 (Ð¾Ð´Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ), Ð±ÐµÐ· ÐÐÐ¡ÐÐ
  // Ð¸ ÐÐ¡, ÑÑÐ¾Ðº Ð¾Ñ 36 Ð¼ÐµÑÑÑÐµÐ², VIN Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½ â Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ Ð±ÑÐº (Bereke.cs).
  BANKS.BEREKE,
  BANKS.HALYK,
  BANKS.SHINHAN,
  BANKS.SAPA,
  // MyCar Finance ÑÐ°Ð±Ð¾ÑÑ Ñ Ð¿ÑÐ¾Ð±ÐµÐ³Ð¾Ð¼ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸Ð» (Ð¿ÐµÑÐµÐ¿Ð¸ÑÐºÐ° Ñ Ð±Ð°Ð½ÐºÐ¾Ð¼ 02.10.2026):
  // Ð² Ð·Ð°ÑÐ²ÐºÑ ÑÑÐ¾Ð´Ð¸Ñ Ð¿ÑÐ¸Ð·Ð½Ð°Ðº Â«Ð½Ðµ Ð½Ð¾Ð²ÑÐ¹Â», VIN Ð¸ Ð¿ÑÐ¾Ð±ÐµÐ³. ÐÐ°Ð½Ðº Ð²Ð¸Ð´ÐµÐ½ Ð² Ð²ÑÐ±Ð¾ÑÐµ ÑÐ¾Ð»ÑÐºÐ¾
  // Ð² ÑÐ±Ð¾ÑÐºÐµ Ñ REACT_APP_MYCAR_ENABLED=true, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ¿Ð¸ÑÐ¾Ðº Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑÑÑ.
  BANKS.MYCAR,
  // Jet Finance Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð¸ ÐÐ£, Ð¸ Ð½Ð¾Ð²ÑÐµ: Ñ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ ÑÑÐ°Ð²Ð¸Ð¼ Ð¿ÑÐ¸Ð·Ð½Ð°Ðº is_new,
  // Ð¸ Ð³Ð¾ÑÐ½Ð¾Ð¼ÐµÑ Ñ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ¾Ð¼ Ð±Ð°Ð½Ðº Ð½Ðµ ÑÑÐµÐ±ÑÐµÑ. ÐÐ¸Ð´ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ±Ð¾ÑÐºÐµ Ñ
  // REACT_APP_JETFIN_ENABLED=true â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ¿Ð¸ÑÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ.
  BANKS.JETFIN,
  // PledgeCar â ÐºÐ¾Ð½Ð²ÐµÐ¹ÐµÑ Ð¡Ð°Ð¿Ñ: Ð¿ÑÐ¸Ð·Ð½Ð°Ðº isNewAuto, Ð¿ÑÐ¾Ð±ÐµÐ³ Ð¸ VIN. ÐÐ¸Ð´ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð²
  // ÑÐ±Ð¾ÑÐºÐµ Ñ REACT_APP_PLEDGECAR_ENABLED=true â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ¿Ð¸ÑÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ.
  BANKS.PLEDGECAR,
  // Solva Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð¸ Ð½Ð¾Ð²ÑÐµ, Ð¸ Ñ Ð¿ÑÐ¾Ð±ÐµÐ³Ð¾Ð¼: Ñ Ð½ÐµÑ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾Ð´ÑÐºÑ USED_CAR,
  // Ð² Ð·Ð°ÑÐ²ÐºÑ ÑÑÐ¾Ð´ÑÑ ÐºÐ°ÑÐµÐ³Ð¾ÑÐ¸Ñ, Ð¿ÑÐ¾Ð±ÐµÐ³ Ð¸ VIN. ÐÐ¸Ð´Ð½Ð° ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ±Ð¾ÑÐºÐµ Ñ
  // REACT_APP_SOLVA_ENABLED=true â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ¿Ð¸ÑÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ.
  BANKS.SOLVA,
];

// ÐÐ¾Ð³Ð¾ÑÐ¸Ð¿ Solva Ð»ÐµÐ¶Ð¸Ñ Ð² wwwroot ÑÐ¾Ð³Ð¾ Ð¶Ðµ Ð±ÑÐºÐ°, ÑÑÐ¾ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°ÐµÑ ÐºÐ¾Ð½ÑÑÑ
// (images/banks/logo/solva.svg), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÐ¼ ÑÑÑÐ»ÐºÑ Ð¾Ñ Ð°Ð´ÑÐµÑÐ° API, Ð° Ð½Ðµ
// Ð²ÑÐ¸Ð²Ð°ÐµÐ¼ Ð¿ÑÐ¾Ð´, ÐºÐ°Ðº Ñ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¿Ð¾ÑÑÐ°ÑÑÐµ: Ð½Ð° ÑÐµÑÑÐµ Ð²ÑÐ¸ÑÑÐ¹ Ð¿ÑÐ¾Ð´ Ð¾ÑÐ´Ð°Ð²Ð°Ð» Ð±Ñ 404,
// Ð¿Ð¾ÐºÐ° ÑÐ°Ð¹Ð» Ð½Ðµ ÑÐµÑÐ°Ð» ÑÑÐ´Ð° ÑÐµÐ³Ð¾Ð¼.
export const SOLVA_LOGO = `${String(apiUrl || '').replace(/\/+$/, '')}/images/banks/logo/solva.svg`;

export const BANKS_OPTIONS = [
  { value: BANKS.EURAZ, label: 'Eurasian Bank' },
  { value: BANKS.BCK, label: 'Bank CenterCredit', image: 'http://app.doscar.kz/images/banks/logo/bcc.png' },
  { value: BANKS.FREEDOM, label: 'Freedom Bank', image: 'https://app.doscar.kz/images/banks/logo/Freedom.png' },
  { value: BANKS.BEREKE, label: 'Bereke Bank', image: 'http://app.doscar.kz/images/banks/logo/Bereke.png' },
  { value: BANKS.HALYK, label: 'Halyk Bank', image: 'http://app.doscar.kz/images/banks/logo/halyk.png' },
  { value: BANKS.FORTE, label: 'ForteBank', image: 'http://app.doscar.kz/images/banks/logo/forte.png' },
  { value: BANKS.SHINHAN, label: 'Shinhan Bank', image: 'http://app.doscar.kz/images/banks/logo/shinhan.png' },
  { value: BANKS.ALTYN, label: 'Altyn Bank', image: 'https://app.doscar.kz/images/banks/logo/altyn.png' },
  { value: BANKS.SAPA, label: 'Sapa Digital Finance' },
  // Ð¢Ð¤Ð¡ Ð¾ÑÐºÐ»ÑÑÑÐ½: Ñ ÑÐµÐ½ÑÑÐ±ÑÑ 2026 Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð·Ð°ÑÐ²ÐºÐ¸ â Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÑÑ Ð¿ÑÐ¸Ð½ÑÑÐ°Ñ
  // Ð±ÑÐ»Ð° 22.09.2025, Ð´Ð°Ð»ÑÑÐµ 69 ÑÑÑÑÑ Ð·Ð°ÑÐ²Ð¾Ðº ÑÑÐ»Ð¸ Ð² Ð½Ð¸ÐºÑÐ´Ð°. Ð£Ð±ÑÐ°Ð½ Ð¸Ð· Ð²ÑÐ±Ð¾ÑÐ°, ÑÑÐ¾Ð±Ñ
  // Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÐµÐ³Ð¾ Ð½Ðµ Ð¾ÑÐ¼ÐµÑÐ°Ð», Ð° ÐºÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°Ð» ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð² ÐµÐ³Ð¾ Ð¿Ð¾Ð»ÑÐ·Ñ.
  // { value: BANKS.TFS, label: 'TFS', image: 'https://app.doscar.kz/images/banks/logo/tfs.jpg' },
  // MyCar Finance (ÐÐ¤Ð): Ð·Ð°Ð¿ÑÑÐº 09.2026. ÐÐ¾ÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐµÐ¼ Ð½Ð° ÑÐµÑÑÐµ, Ð² Ð²ÑÐ±Ð¾ÑÐµ Ð±Ð°Ð½ÐºÐ¾Ð²
  // Ð¾Ð½ ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ±Ð¾ÑÐºÐµ Ñ REACT_APP_MYCAR_ENABLED=true â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ Ð½Ðµ Ð²Ð¸Ð´ÐµÐ½.
  ...(process.env.REACT_APP_MYCAR_ENABLED === 'true' ? [{ value: BANKS.MYCAR, label: 'mycar finance' }] : []),
  // Jet Finance (ÑÐ¸ÑÑÐµÐ¼Ð° Rubie): Ð·Ð°Ð¿ÑÑÐº 10.2026, Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÑÑ. Ð­ÑÐ¾ Ð±Ð°Ð½Ðº,
  // Ð½Ðµ Ð½Ð°Ñ Ð±ÑÐ¾ÐºÐµÑ JetQ. ÐÐ° Ð¿ÑÐ¾Ð´Ðµ Ð¾Ð¿ÑÐ¸Ð¸ Ð½ÐµÑ â ÑÐ±Ð¾ÑÐºÐ° Ð±ÐµÐ· REACT_APP_JETFIN_ENABLED.
  ...(process.env.REACT_APP_JETFIN_ENABLED === 'true'
    ? [{ value: BANKS.JETFIN, label: 'Jet Finance', image: 'https://app.doscar.kz/images/banks/logo/jetfin.png' }]
    : []),
  // Solva (ÐÐ¤Ð): Ð¸Ð½ÑÐµÐ³ÑÐ°ÑÐ¸Ñ Ñ 10.2026, Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÑÑ â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ±Ð¾ÑÐºÐ° Ð±ÐµÐ·
  // REACT_APP_SOLVA_ENABLED, Ð¾Ð¿ÑÐ¸Ð¸ Ð½ÐµÑ.
  ...(process.env.REACT_APP_SOLVA_ENABLED === 'true'
    ? [{ value: BANKS.SOLVA, label: 'Solva', image: SOLVA_LOGO }]
    : []),
  // PledgeCar (ÐÐ¤Ð Ð½Ð° ÐºÐ¾Ð½Ð²ÐµÐ¹ÐµÑÐµ Ð¡Ð°Ð¿Ñ): Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÑÑ â Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ±Ð¾ÑÐºÐ° Ð±ÐµÐ·
  // REACT_APP_PLEDGECAR_ENABLED, Ð¾Ð¿ÑÐ¸Ð¸ Ð½ÐµÑ. ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ â Ð·Ð°Ð³Ð»ÑÑÐºÐ¸.
  ...(process.env.REACT_APP_PLEDGECAR_ENABLED === 'true' ? [{ value: BANKS.PLEDGECAR, label: 'PledgeCar' }] : []),
  // { value: BANKS.TEST, label: 'TEST', image: "https://app.doscar.kz/images/banks/logo/test.png"},
];

export const DEAL_STEPS = {
  FINISH: 10,
  SELECT_BANKS: 5,
  NOTARIAL_DOCUMENTS: 6,
  CAR_DELIVERY: 9,
  CLIENT_PAYMENT_APPROVE: 100,
  CLIENT_REGISTRATION_APPROVE: 101,
  SIGN_CONTRACT: 102,
  // ÐÐ²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ: ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ ÑÐ¾ÑÐ¼Ð¸ÑÑÐµÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ°
  // Ð±Ð°Ð½ÐºÐ° Ð¸ Ð´Ð¾ ÐÐÐ. ÐÐ»Ñ Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÑÐ¾ÐºÐ° ÑÐ°Ð³ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÑÑÑ.
  TRIPARTITE_CONTRACT: 103,
  HALYK: {
    SIGN_CONTRACT: 200,
    NOTARIAL_VERIFICATION: 20,
    WAITING_FOR_PAYMENT: 21,
    AUTO_REGISTRATION: 22,
    WAITING_FOR_FINAL_ACTIONS: 23,
    CAR_DELIVERY: 24,
    SHOW_GUARANTEE_LETTER: 25,
  },
  FREEDOM: {
    SIGN_CONTRACT: 300,
    WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE: 31,
    WAITING_FOR_CLIENT_DOCUMENTS: 32,
    WAITING_FOR_PAYMENT: 33,
    AUTO_REGISTRATION: 34,
    WAITING_FOR_FINAL_ACTIONS: 35,
  },
  FORTE: {
    NOTARIAL_VERIFICATION: 41,
    WAITING_FOR_CLIENT_DOCUMENTS: 42,
    WAITING_FOR_PAYMENT: 43,
    AUTO_REGISTRATION: 44,
    AUTO_REREGISTRATION: 49,
    WAITING_FOR_FINAL_ACTIONS: 45,
    CAR_DELIVERY: 46,
    WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_MOBILE_APP: 47,
    WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_SIDE: 48,
    WAITING_NEW_STATUS: 411,
    SIGN_CONTRACT: 422,
  },
  BEREKE: {
    SIGN_CONTRACT: 500,
    WAITING_FOR_CLIENT_ACTIONS: 50,
    CAR_DELIVERY: 51,
  },
  BCK: {
    SIGN_CONTRACT: 600,
    NOTARIAL_VERIFICATION: 61,
    WAITING_FOR_PAYMENT: 62,
    WAITING_BANK_ACTIONS: 63,
    AUTO_REREGISTRATION: 64,
    CAR_DELIVERY: 65,
  },
  SHINHAN: {},
  ALTYN: {
    SIGN_CONTRACT: 80,
    WAITING_FOR_PAYMENT: 81,
    AUTO_REREGISTRATION: 84,
  },
  // Ð£ Solva Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð½ÐµÑ: Ð¿Ð¾ÑÐ»Ðµ Ð½Ð¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÑ ÑÑÐ°Ð·Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡
  // Ð¸ Ð²ÑÐ´Ð°ÑÐ°. ÐÐÐ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑÑÑ Ð¾Ð±ÑÐ¸Ð¼ ÑÐ°Ð³Ð¾Ð¼ SIGN_CONTRACT Ð² Ð½Ð°ÑÐ°Ð»Ðµ Ð¿Ð¾ÑÐ¾ÐºÐ°.
  SOLVA: {
    AUTO_REGISTRATION: 1501,
    CAR_DELIVERY: 1502,
  },
  EURAZ: {
    SIGN_CONTRACT: 1001,
    AUTO_REGISTRATION: 1002,
    CAR_DELIVERY: 1003,
    DOCUMENTS_FOR_USED_CAR: 1008,
    WAITING_FOR_PAYMENT: 1004,
    NOTARIAL_VERIFICATION: 1005,
    EDIT_CAR_GOS_NUMBER: 1006,
    ADIITIONAL_DOCUMENTS: 1007,
  },
};
